import Vue from 'vue'
import $ from 'jquery'
// eslint-disable-next-line
import slick from 'slick-carousel'
// import Arrow from 'templates/left-arrow.html'

const HeroSlider = Vue.directive('hero-slider', {
  bind (el) {
    $(document).ready(function () {
      const slider = $(el)
      slider.slick({
        arrows: false,
        autoplay: true,
        speed: 4000,
        fade: true,
        dots: false,
        infinite: true
      })
    })
  }
})

export default HeroSlider



// WEBPACK FOOTER //
// ./src/components/hero/hero-home/hero-home.directive.js